export function formatPrices(suffix) {
   const data_price = `[data-format-price${suffix ? '-' + suffix : ''}]`
   const prices = document.querySelectorAll(data_price)

   prices.forEach((price) => {
      if (price.classList.contains('price--formatted')) return

      const str = price.textContent.replace('$', '').trim()
      const _p = parseFloat(str).toLocaleString('es-ES', {
         minimumFractionDigits: 0,
         maximumFractionDigits: 0,
      })
      price.textContent = `$${_p}`

      price.classList.add('price--formatted')
   })
}
